import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { Spin } from "antd";
import { useHistory } from "react-router-dom";
import {
  useGetLoyaltyDetailsByBrandNameMutation,
  useUpdateLoyaltyMutation,
  useCreateLoyaltyMutation,
} from "redux/loyalty/loyalty-service";
import { UTILS } from "utils";
import { CONSTANTS as C } from "config";
import LoyaltyForm from "../components/LoyaltyForm";
import AppContainer from "components/ui/AppContainer";
import AppButton from "components/ui/AppButton";
const AddUpdateLoyaltyProgram = () => {
  const history = useHistory();
  const { isLoading } = useSelector((state) => state.LoaderReducer);
  const [getLoyaltyDetailsByBrandName] =
    useGetLoyaltyDetailsByBrandNameMutation();
  const [updateLoyalty] = useUpdateLoyaltyMutation();
  const [createLoyality] = useCreateLoyaltyMutation();
  const [actionType, setActionType] = useState(C.LOYALTY_CONSTANTS.ADD_OP);
  const {
    register,
    handleSubmit,
    watch,
    trigger,
    setValue,
    reset,
    formState: { errors, isValid },
  } = useForm(
    {
      mode: "onChange",
      defaultValues: async () => {
        const loyaltyDetails = await fetchLoyaltyDetails();
        return loyaltyDetails;
      },
    },
    []
  );

  const fetchLoyaltyDetails = async () => {
    reset();
    const userDetail = UTILS.getCurrentUser();
    if (userDetail?.brandId) {
      const { data } = await getLoyaltyDetailsByBrandName({
        brandId: userDetail.brandId,
      });
      if (data?.success === 1 && data?.data && data?.data?._id) {
        setActionType(C.LOYALTY_CONSTANTS.EDIT_OP);
      } else {
        setActionType(C.LOYALTY_CONSTANTS.ADD_OP);
      }
      reset(data?.data);
      return data?.data;
    }
  };

  /* 
    This function is used to add or update loyalty program
  */
  const addUpdateLoyaltyInfo = async (data) => {
    const commonData = {
      minOrderValueForCashback: 0,
      redeemablePercentagePerOrder: Number(data.redeemablePercentagePerOrder),
      maxRedeemableValuePerOrder: Number(data.maxRedeemableValuePerOrder),
      welcomeBonus: {
        ...data.welcomeBonus,
        value: Number(data.welcomeBonus.value || 0),
      },
    };

    let obj = {
      ...data,
      specificToDelivery: {
        isActive: true,
        cashbackPercentage: Number(data.specificToDelivery.cashbackPercentage),
      },
      specificToPickup: {
        isActive: true,
        cashbackPercentage: Number(data.specificToDelivery.cashbackPercentage),
      },
      specificToDineIn: {
        isActive: true,
        cashbackPercentage: Number(data.specificToDelivery.cashbackPercentage),
      },
    };
    if (actionType === C.LOYALTY_CONSTANTS.ADD_OP) {
      obj = {
        ...obj,
        ...commonData,
      };
      await createLoyality(obj);
    } else {
      obj = {
        ...obj,
        loyaltyId: data._id,
        specificToDelivery: {
          ...data.specificToDelivery,
          cashbackPercentage: Number(
            data.specificToDelivery.cashbackPercentage
          ),
        },
        ...commonData,
      };

      await updateLoyalty(obj);
    }

    await fetchLoyaltyDetails();
  };

  return (
    <Spin spinning={isLoading}>
      <AppContainer
        title={
          actionType === C.LOYALTY_CONSTANTS.ADD_OP ? "Add Loyalty" : "Update Loyalty"
        }
        subTitle="Enable and manage a loyalty program for your customers."
        footer={
          <div className="flex items-center justify-end gap-3">
            <AppButton
              type="button"
              variant="outline"
              size="md"
              onClick={() => history.goBack()}
            >
              No, Cancel
            </AppButton>
            <AppButton
              type="submit"
              form="loyalty-form"
              variant="primary"
              size="md"
              disabled={
                actionType === C.LOYALTY_CONSTANTS.ADD_OP && !watch("isLoyaltyActive")
              }
            >
              {actionType === C.LOYALTY_CONSTANTS.EDIT_OP
                ? "Save Changes"
                : "Create Loyalty"}
            </AppButton>
          </div>
        }
      >
        <div className="flex w-full flex-col">
          <LoyaltyForm
            {...{
              register,
              errors,
              watch,
              actionType,
              isValid,
              trigger,
              setValue,
            }}
            onsubmit={handleSubmit(addUpdateLoyaltyInfo)}
          />
        </div>
      </AppContainer>
    </Spin>
  );
};

export default AddUpdateLoyaltyProgram;
